<template>
  <footer
    class="footer-shell relative overflow-hidden border-t border-[var(--footer-border)] bg-[var(--footer-bg)] text-[var(--footer-text)] transition-colors duration-300"
  >
    <!-- ambient -->
    <div
      class="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
    >
      <div class="footer-grid absolute inset-0"></div>

      <div
        class="footer-orb footer-orb-one absolute rounded-full blur-3xl"
      ></div>

      <div
        class="footer-orb footer-orb-two absolute rounded-full blur-3xl"
      ></div>
    </div>

    <div
      class="relative mx-auto max-w-7xl px-5 pb-8 pt-12 sm:px-6 sm:pt-16 lg:px-8"
    >


      <!-- MAIN -->
      <div
        class="grid gap-12 lg:grid-cols-12 lg:gap-10"
      >
        <!-- BRAND -->
        <div class="lg:col-span-5">
          <router-link
            to="/"
            class="group inline-flex items-center gap-3"
          >
            <div
              class="grid h-10 w-10 place-items-center rounded-2xl bg-[var(--footer-primary)] text-xs font-bold text-[var(--footer-primary-text)] shadow-sm transition duration-300 group-hover:scale-[1.04]"
            >
              G
            </div>

            <div>
              <span
                class="block text-sm font-semibold tracking-tight text-[var(--footer-heading)]"
              >
                Grivaro Studio
              </span>

              <span
                class="mt-0.5 block text-[10px] font-semibold uppercase tracking-[0.16em] text-[var(--footer-muted-2)]"
              >
                Product Engineering
              </span>
            </div>
          </router-link>

          <p
            class="mt-6 max-w-md text-sm leading-7 text-[var(--footer-muted)]"
          >
            Produtos digitais, sistemas internos e integrações sob medida
            para operações que precisam de mais clareza, velocidade e precisão.
          </p>

          <div
            class="mt-7 flex flex-wrap gap-2"
          >
            <span
              v-for="item in specialties"
              :key="item"
              class="rounded-full border border-[var(--footer-border)] bg-[var(--footer-chip)] px-3 py-2 text-[11px] font-semibold text-[var(--footer-muted)]"
            >
              {{ item }}
            </span>
          </div>

          <div
            class="mt-7 inline-flex items-center gap-2 rounded-full border border-[var(--footer-border)] bg-[var(--footer-chip)] px-3 py-2 text-xs font-semibold text-[var(--footer-muted)]"
          >
            <span class="relative flex h-2 w-2">
              <span
                class="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-40"
              ></span>

              <span
                class="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"
              ></span>
            </span>

            Projetos sob consulta
          </div>
        </div>

        <!-- LINKS -->
        <div
          class="grid gap-8 sm:grid-cols-3 lg:col-span-7"
        >
          <!-- MAPA -->
          <div>
            <h4
              class="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--footer-heading)]"
            >
              Mapa
            </h4>

            <ul
              class="mt-5 space-y-3 text-sm"
            >
              <li
                v-for="item in navigation"
                :key="item.path"
              >
                <router-link
                  :to="item.path"
                  class="group inline-flex items-center gap-2 text-[var(--footer-muted)] transition duration-300 hover:translate-x-0.5 hover:text-[var(--footer-heading)]"
                >
                  <span
                    class="h-1 w-1 rounded-full bg-[var(--footer-muted-2)] transition duration-300 group-hover:bg-[var(--footer-heading)]"
                  ></span>

                  {{ item.label }}
                </router-link>
              </li>
            </ul>
          </div>

          <!-- ESPECIALIDADES -->
          <div>
            <h4
              class="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--footer-heading)]"
            >
              Especialidades
            </h4>

            <ul
              class="mt-5 space-y-3 text-sm text-[var(--footer-muted)]"
            >
              <li
                v-for="item in expertise"
                :key="item"
                class="transition duration-300 hover:translate-x-0.5 hover:text-[var(--footer-heading)]"
              >
                {{ item }}
              </li>
            </ul>
          </div>

          <!-- CONTATO -->
          <div>
            <h4
              class="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--footer-heading)]"
            >
              Contato
            </h4>

            <ul
              class="mt-5 space-y-3 text-sm"
            >
              <li
                v-for="item in socials"
                :key="item.label"
              >
                <a
                  :href="item.href"
                  target="_blank"
                  rel="noopener"
                  class="group inline-flex items-center gap-2 text-[var(--footer-muted)] transition duration-300 hover:translate-x-0.5 hover:text-[var(--footer-heading)]"
                >
                  <span>
                    {{ item.label }}
                  </span>

                  <span
                    class="text-[10px] text-[var(--footer-muted-2)] transition duration-300 group-hover:translate-x-0.5"
                    aria-hidden="true"
                  >
                    ↗
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- BOTTOM -->
      <div
        class="mt-12 flex flex-col gap-5 border-t border-[var(--footer-border)] pt-6 text-xs text-[var(--footer-muted)] sm:flex-row sm:items-center sm:justify-between"
      >
        <p>
          © {{ year }} Grivaro Studio. Todos os direitos reservados.
        </p>

        <div
          class="flex flex-wrap items-center gap-x-4 gap-y-2"
        >
          <span>
            Design, software e automação sob medida.
          </span>

          <span
            class="hidden h-1 w-1 rounded-full bg-[var(--footer-muted-2)] sm:block"
            aria-hidden="true"
          ></span>

          <span
            class="inline-flex items-center gap-1.5"
          >
            <span
              class="h-1.5 w-1.5 rounded-full bg-emerald-500"
            ></span>

            Online
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const year =
  new Date().getFullYear()

const whatsHref =
  'https://wa.me/5577999631644'

const navigation = [
  {
    label: 'Início',
    path: '/'
  },
  {
    label: 'Soluções',
    path: '/solutions'
  },
  {
    label: 'Projetos',
    path: '/projects'
  },
  {
    label: 'Templates',
    path: '/templates'
  },
  {
    label: 'Blog',
    path: '/blog'
  }
]

const specialties = [
  'SaaS',
  'Sistemas',
  'Integrações',
  'Automação'
]

const expertise = [
  'Produtos digitais',
  'Sistemas internos',
  'Integrações',
  'Automação',
  'Landing Pages'
]

const socials = [
  {
    label: 'WhatsApp',
    href: whatsHref
  },
  {
    label: 'GitHub',
    href: 'https://github.com/gabimottadev'
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/gabimottadev/'
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/gabimottadev/'
  }
]
</script>

<style scoped>
.footer-shell {
  isolation:
    isolate;
}

.footer-grid {
  opacity:
    0.32;

  background-image:
    linear-gradient(
      to right,
      var(--footer-grid)
      1px,
      transparent 1px
    ),
    linear-gradient(
      to bottom,
      var(--footer-grid)
      1px,
      transparent 1px
    );

  background-size:
    54px 54px;

  mask-image:
    linear-gradient(
      to bottom,
      black,
      transparent 72%
    );
}

.footer-orb {
  opacity:
    0.72;
}

.footer-orb-one {
  width:
    28rem;

  height:
    28rem;

  right:
    -10rem;

  top:
    -10rem;

  background:
    var(--footer-orb-one);
}

.footer-orb-two {
  width:
    24rem;

  height:
    24rem;

  left:
    -9rem;

  bottom:
    -12rem;

  background:
    var(--footer-orb-two);
}

.footer-bridge {
  transition:
    transform 350ms ease,
    border-color 350ms ease,
    box-shadow 350ms ease;
}

.footer-bridge:hover {
  transform:
    translateY(-2px);

  border-color:
    color-mix(
      in srgb,
      var(--footer-heading) 13%,
      transparent
    );
}

@media (
  prefers-reduced-motion:
  reduce
) {
  *,
  *::before,
  *::after {
    animation-duration:
      0.01ms !important;

    animation-iteration-count:
      1 !important;

    transition-duration:
      0.01ms !important;
  }
}
</style>

<style>
:root {
  --footer-bg:
    rgba(255, 255, 255, 0.90);

  --footer-glass:
    rgba(255, 255, 255, 0.72);

  --footer-chip:
    rgba(245, 245, 247, 0.84);

  --footer-heading:
    #09090b;

  --footer-text:
    #3f3f46;

  --footer-muted:
    #71717a;

  --footer-muted-2:
    #a1a1aa;

  --footer-border:
    rgba(24, 24, 27, 0.085);

  --footer-primary:
    #09090b;

  --footer-primary-text:
    #ffffff;

  --footer-focus:
    rgba(24, 24, 27, 0.1);

  --footer-grid:
    rgba(24, 24, 27, 0.04);

  --footer-orb-one:
    rgba(203, 213, 225, 0.34);

  --footer-orb-two:
    rgba(226, 232, 240, 0.34);

  --footer-shadow:
    0 18px 55px
    rgba(24, 24, 27, 0.08);
}

html[data-theme='dark'] {
  --footer-bg:
    rgba(9, 10, 12, 0.96);

  --footer-glass:
    rgba(20, 21, 24, 0.72);

  --footer-chip:
    rgba(255, 255, 255, 0.045);

  --footer-heading:
    #fafafa;

  --footer-text:
    #e4e4e7;

  --footer-muted:
    #a1a1aa;

  --footer-muted-2:
    #5f6169;

  --footer-border:
    rgba(255, 255, 255, 0.085);

  --footer-primary:
    #ffffff;

  --footer-primary-text:
    #09090b;

  --footer-focus:
    rgba(255, 255, 255, 0.12);

  --footer-grid:
    rgba(255, 255, 255, 0.035);

  --footer-orb-one:
    rgba(63, 63, 70, 0.22);

  --footer-orb-two:
    rgba(30, 41, 59, 0.24);

  --footer-shadow:
    0 18px 60px
    rgba(0, 0, 0, 0.34);
}
</style>
